import { useParams, Link } from 'react-router-dom';
import { ChevronRight, FileText } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { getCategoryById, getDocumentsByCategory } from '../data/documents';

export default function CategoryPage() {
  const { categoryId } = useParams();
  const category = getCategoryById(categoryId);
  const documents = getDocumentsByCategory(categoryId);
  
  if (!category) {
    return (
      <div className="min-h-screen flex flex-col bg-white">
        <Header showBack backTo="/" />
        <main className="flex-1 flex items-center justify-center">
          <div className="text-center">
            <h1 className="text-2xl font-bold mb-4">Catégorie non trouvée</h1>
            <Link to="/" className="btn-primary inline-flex items-center gap-2">
              Retour à l'accueil
            </Link>
          </div>
        </main>
        <Footer />
      </div>
    );
  }
  
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header showBack backTo="/" />
      
      <main className="flex-1">
        {/* Category Header */}
        <section className="bg-slate-50 py-8 md:py-12">
          <div className="container-app">
            {/* Breadcrumb */}
            <nav className="flex items-center gap-2 text-sm text-muted-foreground mb-4">
              <Link to="/" className="hover:text-primary">Accueil</Link>
              <ChevronRight className="w-4 h-4" />
              <span className="text-foreground font-medium">{category.name}</span>
            </nav>
            
            <h1 className="text-2xl sm:text-3xl font-bold text-primary mb-3" data-testid="category-title">
              {category.name}
            </h1>
            <p className="text-muted-foreground max-w-2xl">
              {category.description}
            </p>
          </div>
        </section>
        
        {/* Documents List */}
        <section className="section-spacing">
          <div className="container-app">
            <h2 className="text-xl font-semibold mb-6">
              {documents.length} modèle{documents.length > 1 ? 's' : ''} disponible{documents.length > 1 ? 's' : ''}
            </h2>
            
            <div className="space-y-4">
              {documents.map((doc) => (
                <Link
                  key={doc.id}
                  to={`/document/${doc.id}`}
                  className="card-document group"
                  data-testid={`document-card-${doc.id}`}
                >
                  <div className="flex items-start gap-4 flex-1 min-w-0">
                    <div className="w-10 h-10 bg-slate-100 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-blue-50">
                      <FileText className="w-5 h-5 text-slate-600 group-hover:text-primary" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <h3 className="font-semibold text-slate-900 group-hover:text-primary mb-1">
                        {doc.name}
                      </h3>
                      <p className="text-sm text-muted-foreground line-clamp-2">
                        {doc.description}
                      </p>
                    </div>
                  </div>
                  
                  <div className="flex items-center gap-2 flex-shrink-0 ml-4">
                    <span className="text-sm font-medium text-accent hidden sm:block">4,99 €</span>
                    <ChevronRight className="w-5 h-5 text-slate-400 group-hover:text-primary" />
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
}
